import React from 'react';
import { Container } from '@mui/material';
import LogoSvg from '../svg/logo.svg';
import Dropdown from '../shared/dropdown';
import { Link } from 'react-router-dom';

const Navmenu = () => {
    return (
        <Container maxWidth="lg">
            <div className="navmenu">
                <Link to="/" className="logo"><img src={LogoSvg} alt="Logo" /></Link>
                <div className="support-btn"><Dropdown /></div>
            </div>
        </Container>
    )
}

export default Navmenu